// Startup point for the client side application
import "@babel/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import { renderRoutes } from "react-router-config";
import Routes from "./Routes";
import reducers from "./reducers";
import { axiosContentDetail } from "./axios";
import { LoaderComponent } from "./components/loader";
import "./preferences.css";
import "./menu.css";
import "./fonts.css";
import "./tabs.css";
import "./signInUpFlow.css";
import "./sponsored.css";
import "./error-pages.css";
import "./search.css";
import "react-owl-carousel2/lib/styles.css"; //Allows for server-side rendering.
import "./index.css";
import "./bootstrapOverride.css";
import "./owlCrouselOverride.css";
import "./playerOverride.css";
import "./tier.css";
import "./homePage.css";
import "./webinarConfirmation.css";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;
const enhancer = composeEnhancers(
  applyMiddleware(thunk.withExtraArgument(axiosContentDetail))
);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error, info) {
    console.error('Error caught by error boundary:', error, info);
  }

  render() {
    return this.props.children;
  }
}

const store = createStore(reducers, window.INITIAL_STATE, enhancer);

ReactDOM.hydrate(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter basename="/">
        <div className="relative d-flex flex-column">
          <div className="displaySsr">
            <LoaderComponent isLoading={true} />
          </div>
          {renderRoutes(Routes)}
        </div>
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>,
  document.querySelector("#root")
);
